module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/online-e453b247a2b491d1cb6343798920247d.png";